import { atom } from "recoil";

export const qrDepositeModalAtom = atom<boolean>({
  key: 'qrDepositeModal',
  default: false,
});